import { Container, SiteFooter, SiteHeader } from "./SiteChrome";
import { CmsContent } from "./CmsContent";
import { useCmsBatch } from "../hooks/useCmsBatch";
import { CmsIcon } from "../utils/cmsIcons";

const capabilitiesDefault = [
  { icon: "Gauge", title: "Objective performance tracking", body: "Every session is measured against clear benchmarks, not gut feel." },
  { icon: "Activity", title: "Wearable & GPS data", body: "Speed, acceleration and workload captured automatically during training." },
  { icon: "Camera", title: "Video analysis", body: "Frame-by-frame breakdowns turn technique into a concrete coaching plan." },
  { icon: "BrainCircuit", title: "Data-informed coaching", body: "Coaches adjust each player's plan using the numbers, not assumptions." },
];

const CMS_KEYS = ["technology-hero", "technology-capabilities"];

export function TechnologyPage() {
  const { content } = useCmsBatch(CMS_KEYS);
  const hero = content["technology-hero"] || {};
  const capabilitiesSection = content["technology-capabilities"] || {};
  const capabilities = capabilitiesSection.items?.length ? capabilitiesSection.items : capabilitiesDefault;

  return (
    <>
      <SiteHeader />
      <main>
        <section className="section dark">
          <Container>
            <p className="eyebrow lime"><span>01</span>Technology</p>
            <h2 style={{ fontSize: "clamp(32px, 4vw, 52px)" }}>{hero.title || "The lab behind the training."}</h2>
            <p style={{ color: "var(--muted)", lineHeight: 1.8, marginTop: 16, maxWidth: 680 }}>
              {hero.body || "Formula Soccer Center pairs certified coaching with objective performance technology, so every player's development plan is backed by data, not guesswork."}
            </p>
          </Container>
        </section>

        <section className="section light">
          <Container>
            <p className="eyebrow"><span>02</span>What's inside the lab</p>
            <div className="value-grid">
              {capabilities.map((item) => (
                <div key={item.title} className="value-card">
                  <div className="value-card-icon"><CmsIcon name={item.icon} size={20} strokeWidth={1.5} /></div>
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                </div>
              ))}
            </div>
          </Container>
        </section>

        <section className="section dark">
          <Container>
            <p className="eyebrow lime"><span>03</span>More on our technology</p>
            <CmsContent
              contentKey="technology"
              fallbackTitle=""
              fallbackBody="More detail on our specific tools and equipment is on its way — check back soon."
            />
          </Container>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
